import React from 'react';
const Input = ({ label, error, className='', id, ...rest }) => (
  <div className="w-full">
    {label && <label htmlFor={id} className="block text-sm font-medium text-ink-700 mb-1">{label}</label>}
    <input id={id} className={`input ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-500' : ''} ${className}`} {...rest} />
    {error && <p className="mt-1 text-xs text-red-600">{error}</p>}
  </div>
);
export default Input;
